import cx from 'classnames';
import {ResetImageXY} from '~/CreateFabricGreetingCard/routes/CardCreateDesign/components/ResetImageXY';
import {ResetStyle} from '~/common/fabric/CreateDesign/components/CardEditor/actions/ResetStyle/ResetStyle';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';

import './ContentBase.sass';

export const ContentBase = ({
  title,
  children,
  onCloseClick,
  bodyStyle = {},
  noBodyPadding,
  visible,
  style,
  onResetClick,
  resetDataQaId,
  closeDataQaId,
  className,
  uyoControls = false,
  uyoImage = null,
}) =>
  visible && (
    <div
      className={cx('content_base', {
        [className]: className,
      })}
    >
      <div className="content_base__header">
        <div>
          {uyoControls
            ? <ResetImageXY
                disabled={false}
                label="Reset position"
                dataQaId="step1-imagexy-reset"
                uyoImage={uyoImage}
              />
            : <ResetStyle
                label="Reset"
                style={style}
                onResetClick={onResetClick}
                dataQaId={resetDataQaId}
              />}
        </div>
        <div className="content_base__header__title">
          <Typography as="h1" variant="label2" color="pebble">
            {title}
          </Typography>
        </div>
        <button
          className="content_base__header__close_btn unstyled-button"
          onClick={onCloseClick}
          data-qa-id={closeDataQaId}
          data-impression-tracking="true"
          type="button"
        >
          <CloseLineIcon ratio={0.75} />
        </button>
      </div>
      <div
        className={`content_base__body ${noBodyPadding ? 'content_base__body--no-padding' : ''}`}
        style={bodyStyle}
      >
        {children}
      </div>
    </div>
  );
